import { Controller } from "@hotwired/stimulus"

// Submits the form it is attached to as soon as it renders, so a prefilled form loads its
// result without anyone clicking. The marketplace report preview uses this to run a report
// against the browsing company's data on arrival, and sets `enabled` false when a required
// parameter could not be defaulted — leaving the prefilled form for the visitor to finish.
export default class extends Controller {
  static values = { enabled: Boolean }

  connect() {
    if (!this.enabledValue) return
    // requestSubmit fires the submit event Turbo listens for; .submit() bypasses it. Deferred
    // a frame so the submission never races the page load that is still installing Turbo's
    // own listeners.
    requestAnimationFrame(() => this.element.requestSubmit())
  }
}
